export default class Defect {

    static readonly MOLDING: number = 1;
    static readonly ASSEMBLY: number = 2;
    static readonly PUR_COMP: number = 3;
    static readonly INFO: number = 4;
    static readonly HAND_STOR: number = 5;
    static readonly UNAPP_PROD: number = 6;
    static readonly WELD: number = 7;
    static readonly LABOR_NA: number = 8;
    static readonly EQUIP_NA: number = 9;
    static readonly CORRELATION: number = 10;
    static readonly WRONG_CONTAINER: number = 11;
    static readonly DAMAGED: number = 12;
    static readonly COMPL_RETURN: number = 13;
    static readonly DESIGN_ISSUE: number = 14;
    static readonly HS_ISSUE: number = 15;
    static readonly ID_LABEL_ISSUE: number = 16;
    static readonly WARP: number = 17;
    static readonly MISSING_MATL: number = 18;
    static readonly CUST_ISSUE: number = 19;
    static readonly VENDOR_REL: number = 20;
    static readonly OTHER: number = 21;
    static readonly CUSTOM_CUTTING_DIE = 22;
    
    
    id: number;
    desc: string;
    // bootstrap vue only sees value and text in their selectors
    value: number;
    text: string;

    constructor(){
        this.id = 0;
        this.desc = "";
        this.value = 0;
        this.text = "";
    }

}